<template>
  <div class="support">
    <a-float-button
      type="primary"
      :shape="'circle'"
      :tooltip="'Support'"
      @click="showModal"
      class="bg-p!"
      style="right: 40px"
    >
      <template #icon>
        <CustomerServiceOutlined />
      </template>
    </a-float-button>

    <!-- Support Modal -->
    <a-modal
      v-model:open="modalVisible"
      title="Contact Support"
      :footer="null"
      width="500px"
      destroy-on-close
      :mask-closable="false"
      @cancel="handleCancel"
    >
      <div class="support-content">
        <p class="mb-20px">Have questions or suggestions? Reach out to our support team.</p>
        <a-form
          :model="formState"
          name="support_form"
          autocomplete="off"
          layout="vertical"
          @finish="onSubmit"
        >
          <a-form-item
            label="Email"
            name="email"
            :rules="[
              { required: true, message: 'Please input your email!' },
              { type: 'email', message: 'Please enter a valid email!' },
            ]"
          >
            <a-input v-model:value="formState.email" placeholder="your@email.com" />
          </a-form-item>

          <a-form-item
            label="Message"
            name="message"
            :rules="[{ required: true, message: 'Please enter your message!' }]"
          >
            <a-textarea
              v-model:value="formState.message"
              placeholder="Describe your issue or suggestion"
              :rows="4"
              show-count
              :maxlength="500"
            />
          </a-form-item>

          <a-form-item :wrapper-col="{ offset: 6, span: 18 }" class="mt-8 flex-c">
            <a-button type="primary" html-type="submit" :loading="submitting">Submit</a-button>
          </a-form-item>
        </a-form>
      </div>
    </a-modal>
  </div>
</template>

<script setup lang="ts">
import { ref, reactive } from "vue";
import { CustomerServiceOutlined } from "@ant-design/icons-vue";
import { message } from "ant-design-vue";

// Modal visibility
const modalVisible = ref(false);

// Form state
const formState = reactive({
  email: "",
  message: "",
});

// Loading state for submission
const submitting = ref(false);

// Show modal
const showModal = () => {
  modalVisible.value = true;
};

// Handle cancel
const handleCancel = () => {
  modalVisible.value = false;
  formState.email = "";
  formState.message = "";
};

// Submit handler
const onSubmit = async () => {
  submitting.value = true;
  try {
    const response = await post("tickets/add", { ...formState });
    if (response.success) {
      message.success("Your message has been sent successfully!");
    }
    handleCancel();
  } finally {
    submitting.value = false;
  }
};
</script>
